// extracted by mini-css-extract-plugin
export default {"SaturationSelector":"ShadeSelector_SaturationSelector__HN2Rf","inside":"ShadeSelector_inside__wafwg","handle":"ShadeSelector_handle__+NbW7"};